export default __webpack_public_path__ + "static/media/profile.fcec7506.svg";